"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NuiStream = void 0;
var _os = _interopRequireDefault(require("os"));
var _winstonTransport = _interopRequireDefault(require("winston-transport"));
var _transform = require("./logger/transform");
var _safeCycles = require("./safeCycles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/**
 * A stream wrapper that
 * extends winston-transport.
 *
 * Instances of this stream:
 *
 * * are generally used with NuiTransport
 * * remove Symbols from data object before writing
*/
var NuiStream = exports.NuiStream = /*#__PURE__*/function (_Transport) {
  _inherits(NuiStream, _Transport);
  /**
   * Create a NuiStream.
   * @param {NodeJS.WritableStream} stream - The underlying write-able stream.
   */
  function NuiStream(stream) {
    var _this;
    _classCallCheck(this, NuiStream);
    _this = _callSuper(this, NuiStream);
    _this.stream = stream;
    return _this;
  }

  /**
   * Write a record (any object)
   * to the underlying NodeJS.WritableStream
   * without Symbol properties.
   * @param {NodeJS.WritableStream} stream - The underlying write-able stream.
   */
  _createClass(NuiStream, [{
    key: "write",
    value: function write(record) {
      try {
        var cleanRecord = (0, _transform.removeSymbols)(record);
        if (this.stream._writableState !== null && _typeof(this.stream._writableState) === 'object' && this.stream._writableState.objectMode === false) {
          // this means the stream cannot accept an object chunk to write,
          // so we stringify the record before writing
          var recordString = JSON.stringify(cleanRecord, (0, _safeCycles.safeCycles)()) + ((_os.default === null || _os.default === void 0 ? void 0 : _os.default.EOL) || '\n');
          this.stream.write(recordString);
        } else {
          this.stream.write(cleanRecord);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('NuiStream: Exception trying to write to stream.', e);
      }
    }
  }]);
  return NuiStream;
}(_winstonTransport.default);